<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="themeOptions.options().gauge.gaugeColor">
  <div app-theme-option-content>
    <app-color-picker [itemColor]="color" [color]="themeOptions.options().gauge.gaugeColor" (sendColor)="receiveValue($event)"></app-color-picker>
  </div>
</app-theme-option>